import { BasePathname } from "../config/env";
import { hasAnalyticSearchParamInURL } from "../pages/helpers";
import { AnswerLabelsForAnalytics } from "../data/AnalyticsData";

export const getAnswerLabelById = (currentQuestion, answerId) =>
  currentQuestion.answers.find(
    (answerObject) => answerObject.id === Number(answerId)
  )?.label;

export const setAnalyticsSearchParam = (
  location,
  analyticSearchParam,
  searchParamKey,
  navigate
) => {
  if (
    analyticSearchParam &&
    !hasAnalyticSearchParamInURL(location, searchParamKey, analyticSearchParam)
  ) {
    const url = new URL(location.href);
    url.searchParams.append(searchParamKey, analyticSearchParam);
    const redirectPath = url.pathname.replace(BasePathname, "") + url.search;
    navigate(redirectPath, {
      replace: true
    });
  }
};

export const analyticsSearchParamsTypes = {
  VALUEJOURNEY: "value_journey"
};

export const setAnalyticsLabel = (question, answerId) => {
  const labelForAnalytics = AnswerLabelsForAnalytics[parseInt(answerId)];
  if (labelForAnalytics) return labelForAnalytics;
  return getAnswerLabelById(question, answerId);
};

export const sendEvent = (event, eventName, properties) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(event, eventName, properties);
  }
};
